import React, { ChangeEvent, ReactElement } from "react";
import InputLabel from "@/components/Common/InputLabel/InputLabel";
import InputClearButton from "../Utilities/StyledInputClear/InputClearButton";

const StyledInput = ({
  id,
  type,
  name,
  placeholder,
  className,
  value,
  onChange,
  onKeyDown,
  onClear,
}: {
  id: string;
  type?: "text" | "number";
  name?: string;
  placeholder?: string;
  className?: string;
  value?: string | number | null;
  onChange?: (e: ChangeEvent<HTMLInputElement>) => void;
  onKeyDown?: (e: React.KeyboardEvent<HTMLInputElement>) => void;
  onClear?: () => void;
}): ReactElement => {
  const coreStyles = `rounded h-[50px]  ${
    id == "commodity" ? "pl-6" : "pl-3"
  } border-solid bg-gray-125 outline-none border-b-2 border-gray-500 w-full `;
  const enabledStyles =
    "focus:text-blue-600 focus:border-CostcoAction-focus focus:py-2 focus:pl-1";
  const hideNumberSpinner = `input[type=number]::-webkit-inner-spin-button, input[type=number]::-webkit-outer-spin-button {-webkit-appearance:none;margin:0}  `;

  const showClearButton = onClear && value && String(value).length > 0;
  const paddingRight = showClearButton ? "pr-9" : "pr-3";

  // Handler that wraps the parent's onClear function
  const handleInputClear = (e: React.MouseEvent<HTMLButtonElement>) => {
    if (onClear) {
      onClear();
      const inputElement = e.currentTarget
        .previousElementSibling as HTMLInputElement;
      if (inputElement) {
        inputElement.focus();
      }
    }
  };

  return (
    <div className={className}>
      <style>{hideNumberSpinner}</style>
      <div className="block relative">
        <InputLabel
          id={`input-label-${id.toLowerCase().replace(/\s+/g, "-")}`}
          label={id}
          className="text-nowrap overflow-x-auto"
        />
        <input
          name={name}
          id={id}
          data-testid={`styled-input-${id.toLowerCase().replace(/\s+/g, "-")}`}
          className={`${coreStyles} ${enabledStyles} ${paddingRight}`}
          value={value ?? ""}
          onChange={onChange}
          onKeyDown={onKeyDown}
          placeholder={placeholder}
          type={type ?? "text"}
        />
        {showClearButton && (
          <InputClearButton
            onClear={handleInputClear}
            dataTestID={`clear-input-${id.toLowerCase().replace(/\s+/g, "-")}`}
          />
        )}
      </div>
    </div>
  );
};

export default StyledInput;
